/* eslint-disable react/destructuring-assignment */
/* eslint-disable camelcase */
import React, { useEffect, useRef, useState } from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';
import {
  FormControl, InputLabel, MenuItem, Select,
} from '@mui/material';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ITEM_DEFAULTS } from '../../../../../config/deviceConfig/item_defaults';
import { FORM_DEBOUNCE_TIME } from '../../../../../config/deviceConfig/Values';
import { IDFField } from '../../../../../config/deviceConfig/types';
import { IFormResetRef, FormResetAction } from '../../../ProDeviceCreateEdit/types';

const FIELD_NAME = ITEM_DEFAULTS.ITEM_CREATOR.DEVICE_FIELDS.display_labels_view_type;
type ComponentProps = {
  fieldConfig: IDFField;
  validateForm: number;
  deviceInfo: any;
  resetForm: IFormResetRef;
  onChange: (payload:any, isInitializing?: boolean) => void;
};
interface IformData {
  display_label_type: string;
}
// eslint-disable-next-line import/prefer-default-export
export const ProDeviceFieldLabelViewTypeSelector
: React.FunctionComponent<ComponentProps> = (props) => {
  const [deb, setDeb] = useState<BehaviorSubject<{values: IformData; errors: any} | null>>();

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const onSubmitForm = (formData: IformData) => {};

  const sendDefaults = () => {
    if (!props.fieldConfig || !deb) {
      return;
    }
    deb.next({
      values: {
        display_label_type: props.fieldConfig.default,
      },
      errors: {},
    });
  };

  const formRef = useRef<any>();
  /**
     * Resetting or changing form data from parent
     */
  const refFormReset = useRef<IFormResetRef>({
    ref: 0,
    action: '',
    info: {},
  });
  useEffect(() => {
    if (
      formRef.current
        && props.resetForm.ref > 0
        && props.resetForm.ref > refFormReset.current.ref
    ) {
      refFormReset.current = props.resetForm;
      if (props.resetForm.action === FormResetAction.toCurrentInfo) {
        const values = props.resetForm.info.settings[props.fieldConfig.field];
        formRef.current.setValues({
          display_label_type: values,
        });
      } else {
        formRef.current.resetForm();
      }
    }
  // eslint-disable-next-line react/destructuring-assignment
  }, [props.resetForm]);
  const initilized = useRef(0);
  useEffect(() => {
    const b = new BehaviorSubject<{values: IformData; errors: any} | null>(null);
    setDeb(b);
    const sub = b
      .pipe(
        debounceTime(FORM_DEBOUNCE_TIME),
        map((v) => JSON.stringify(v)),
        distinctUntilChanged(),
        map((v) => JSON.parse(v)),
      )
      .subscribe((v: {values: IformData; errors: any} | null) => {
        if (v == null || props.fieldConfig == null) {
          return;
        }

        const { values, errors } = v;
        const infoData: any = {
          settings: {},
        };
        infoData.settings[props.fieldConfig.field] = values.display_label_type;

        if (initilized.current === 0) {
          props.onChange(
            {
              action: 'data',
              form: FIELD_NAME,
              data: infoData,
              errors,
            },
            true,
          );
          initilized.current = 1;
        } else {
          props.onChange({
            action: 'data',
            form: FIELD_NAME,
            data: infoData,
            errors,
          });
        }
      });

    // send once default data
    sendDefaults();
    return () => {
      sub.unsubscribe();
    };
  }, [props.fieldConfig]);
  useEffect(() => {
    if (formRef && formRef.current !== undefined && props.validateForm !== 0) {
      formRef.current.submitForm();
    }
  }, [props.validateForm]);

  let isEditable = props.fieldConfig != null && props.fieldConfig.editable === true;
  if (isEditable) {
    if (props.deviceInfo.settings[`has_${props.fieldConfig.field}`] === false) {
      isEditable = false;
    }
  }

  return (
    <div>
      <Formik
        innerRef={formRef}
        initialValues={{
          display_label_type: props.fieldConfig.default,
        }}
        validationSchema={Yup.object().shape({
          display_label_type: Yup.string().required('Required'),
        })}
        validateOnChange
        onSubmit={onSubmitForm}
      >
        {({
          errors, handleBlur, handleChange, touched, values, submitForm,
        }) => {
          deb?.next({
            values,
            errors,
          });
          return (
            <form>
              <div className="row">
                <div className="col-md-2">
                  <FormControl
                    size="small"
                    variant="outlined"
                    className="dynamic-ui-form-control"
                  >
                    <InputLabel
                      id="display_label_type-label1"
                      error={Boolean(touched.display_label_type && errors.display_label_type)}
                    >
                      Display Label Type:
                    </InputLabel>
                    <Select
                      labelId="display_label_type-label1"
                      value={values.display_label_type}
                      name="display_label_type"
                      onBlur={handleBlur}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      label="Display Label Type"
                    >
                      <MenuItem value="input_status">Status</MenuItem>
                      <MenuItem value="input_label">Label</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </div>
  );
};
